"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyAmountTransformer = exports.ZERO_CURRENCY = exports.CurrencyAmount = void 0;
const lodash_1 = require("lodash");
class CurrencyAmount {
    amountInDollars;
    isCurrencyAmount = true;
    constructor(amountInDollars) {
        this.amountInDollars = (0, lodash_1.round)(amountInDollars, 2);
    }
    getAsDollars = () => this.amountInDollars;
    getAsCents = () => (0, lodash_1.round)(this.amountInDollars * 100, 0);
    add = (other) => {
        return new CurrencyAmount((0, lodash_1.round)(this.amountInDollars + other.amountInDollars, 2));
    };
    subtract = (other) => {
        return new CurrencyAmount((0, lodash_1.round)(this.amountInDollars - other.amountInDollars, 2));
    };
    equals = (other) => {
        return this.amountInDollars === other.amountInDollars;
    };
    greaterThan = (other) => {
        return this.amountInDollars > other.amountInDollars;
    };
    lessThan = (other) => {
        return this.amountInDollars < other.amountInDollars;
    };
    isZero = () => this.amountInDollars === 0;
    isPositive = () => this.amountInDollars > 0;
    isNegative = () => this.amountInDollars < 0;
    isZeroOrNegative = () => this.amountInDollars <= 0;
    formattedDisplayString = () => `$${this.amountInDollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    // Required for implicit string coercion in template literals and concatenation
    toString = () => this.formattedDisplayString();
}
exports.CurrencyAmount = CurrencyAmount;
exports.ZERO_CURRENCY = new CurrencyAmount(0);
// Transformer for TypeORM columns (stores as native numeric, not JSON)
exports.currencyAmountTransformer = {
    to: (value) => {
        return value === null ? null : value.getAsDollars();
    },
    from: (value) => {
        if (value === null) {
            return null;
        }
        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(num)) {
            return null;
        }
        return new CurrencyAmount(num);
    },
};
